var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "integralList seller-style" },
    [
      _c("h2", { staticClass: "f18 fb normal gray_2" }, [_vm._v("积分管理")]),
      _c(
        "div",
        [
          _c("div", { staticClass: "box20" }),
          _c("p", { staticClass: "f16 pad10_l" }, [_vm._v("基础设置")]),
          _c("div", { staticClass: "box20" }),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.pointsRuleList }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", label: "规则名称", width: "300" }
              }),
              _c("el-table-column", {
                attrs: { prop: "detail", label: "规则详情", width: "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("p", {
                          domProps: { innerHTML: _vm._s(scope.row.detail) }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "p",
                          {
                            staticClass: "blue cursor",
                            on: {
                              click: function($event) {
                                return _vm.setIntegral(scope.row)
                              }
                            }
                          },
                          [_vm._v("设置")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("div", { staticClass: "box30" }),
          _c("p", { staticClass: "f16 pad10_l" }, [_vm._v("发放规则设置")]),
          _c("div", { staticClass: "box10" }),
          _c(
            "el-button",
            {
              staticClass: "mar10_l",
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.handleEdit("", 1)
                }
              }
            },
            [_vm._v("新建规则")]
          ),
          _c("div", { staticClass: "box10" }),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.grantRuleDtlList }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "condition", label: "发放规则", width: "300" }
              }),
              _c("el-table-column", {
                attrs: { prop: "detail", label: "发放数量", width: "100" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "applyCustomer",
                  label: "适用客户",
                  width: "100"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "lastUpdateDate",
                  width: "200",
                  label: "更新时间"
                }
              }),
              _c("el-table-column", {
                attrs: { width: "200", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#1890ff",
                            "inactive-color": "#cccccc",
                            disabled: scope.row.busType === 5
                          },
                          on: {
                            change: function($event) {
                              return _vm.validRuleDtl(scope.row)
                            }
                          },
                          model: {
                            value: scope.row.status,
                            callback: function($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "blue cursor",
                            on: {
                              click: function($event) {
                                return _vm.handleEdit(scope.row.id, 1)
                              }
                            }
                          },
                          [_vm._v("查看")]
                        ),
                        _c("span", { staticClass: "blue pad5_lr" }, [
                          _vm._v("|")
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "blue cursor",
                            on: {
                              click: function($event) {
                                return _vm.deletedRuleDtl(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("div", { staticClass: "box30" }),
          _c("p", { staticClass: "f16 pad10_l" }, [_vm._v("使用规则设置")]),
          _c("div", { staticClass: "box10" }),
          _c(
            "el-button",
            {
              staticClass: "mar10_l",
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.handleEdit("", 2)
                }
              }
            },
            [_vm._v("新建规则")]
          ),
          _c("div", { staticClass: "box10" }),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.consumeRuleDtlList }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "condition", label: "使用条件", width: "300" }
              }),
              _c("el-table-column", {
                attrs: { prop: "detail", label: "使用数量", width: "200" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "lastUpdateDate",
                  width: "200",
                  label: "更新时间"
                }
              }),
              _c("el-table-column", {
                attrs: { width: "200", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#1890ff",
                            "inactive-color": "#cccccc"
                          },
                          on: {
                            change: function($event) {
                              return _vm.validRuleDtl(scope.row)
                            }
                          },
                          model: {
                            value: scope.row.status,
                            callback: function($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "blue cursor",
                            on: {
                              click: function($event) {
                                return _vm.handleEdit(scope.row.id, 2)
                              }
                            }
                          },
                          [_vm._v("查看")]
                        ),
                        _c("span", { staticClass: "blue pad5_lr" }, [
                          _vm._v("|")
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "blue cursor",
                            on: {
                              click: function($event) {
                                return _vm.deletedRuleDtl(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "积分发放",
            visible: _vm.ruleCheckVisible,
            width: "700px"
          },
          on: {
            "update:visible": function($event) {
              _vm.ruleCheckVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c("div", { staticClass: "mar20_b" }, [
              _c("span", [_vm._v("适用人群：")]),
              _vm.ruleDtl.applyCustomerType === 1
                ? _c("span", [_vm._v("全部人群")])
                : _vm._e(),
              _vm.ruleDtl.applyCustomerType === 2
                ? _c("span", [_vm._v("客户分组")])
                : _vm._e(),
              _vm.ruleDtl.applyCustomerType === 3
                ? _c("span", [_vm._v("指定客户")])
                : _vm._e()
            ]),
            _c("div", { staticClass: "mar20_b" }, [
              _c("span", [_vm._v("规则详情：")]),
              _vm.ruleDtl.busType === 1
                ? _c(
                    "span",
                    [
                      _vm._v("\n          根据订单发放，\n          "),
                      _vm.ruleDtl.ruleType === 2
                        ? [
                            _vm._v(
                              "订单每满" +
                                _vm._s(_vm.ruleDtl.ruleKey2) +
                                "元，发放" +
                                _vm._s(_vm.ruleDtl.ruleValue2) +
                                _vm._s(_vm.ruleDtl.name)
                            )
                          ]
                        : _vm._e(),
                      _vm.ruleDtl.ruleType === 3
                        ? [
                            _vm._v(
                              "每笔订单发放订单金额的" +
                                _vm._s(_vm.ruleDtl.ruleValue3) +
                                "%"
                            )
                          ]
                        : _vm._e(),
                      _vm._v("\n          。\n        ")
                    ],
                    2
                  )
                : _vm._e(),
              _vm.ruleDtl.busType === 4
                ? _c("span", [
                    _vm._v(
                      "根据评论发放，每个好评评论字数达到" +
                        _vm._s(_vm.ruleDtl.ruleKey4) +
                        "字，发放" +
                        _vm._s(_vm.ruleDtl.name) +
                        "。"
                    )
                  ])
                : _vm._e(),
              _vm.ruleDtl.busType === 2
                ? _c(
                    "span",
                    [
                      _vm._v("根据商品发放，\n          "),
                      _vm.ruleDtl.goodRuleType === 1
                        ? [
                            _vm._v(
                              "每种商品成功交易" +
                                _vm._s(_vm.ruleDtl.goodRuleKey1) +
                                "件，发放" +
                                _vm._s(_vm.ruleDtl.goodRuleValue1) +
                                _vm._s(_vm.ruleDtl.name)
                            )
                          ]
                        : _vm._e(),
                      _vm.ruleDtl.goodRuleType === 2
                        ? [
                            _vm._v(
                              "每种商品每成功交易" +
                                _vm._s(_vm.ruleDtl.goodRuleKey2) +
                                "元，发放" +
                                _vm._s(_vm.ruleDtl.goodRuleValue2) +
                                _vm._s(_vm.ruleDtl.name)
                            )
                          ]
                        : _vm._e(),
                      _vm.ruleDtl.goodRuleType === 3
                        ? [
                            _vm._v(
                              "每件商品，发放订单中该商品金额的" +
                                _vm._s(_vm.ruleDtl.goodRuleValue3) +
                                "%"
                            )
                          ]
                        : _vm._e(),
                      _vm._v("\n          。\n        ")
                    ],
                    2
                  )
                : _vm._e(),
              _vm.ruleDtl.busType === 5
                ? _c(
                    "span",
                    [
                      _vm._v("\n          累计发放，\n          "),
                      _vm.ruleDtl.sbusType === 1
                        ? [_vm._v(" 按消费金额发放 ")]
                        : _vm._e(),
                      _vm.ruleDtl.sbusType === 2
                        ? [_vm._v(" 按商品发放 ")]
                        : _vm._e(),
                      _vm._v("\n          。\n        ")
                    ],
                    2
                  )
                : _vm._e()
            ]),
            _vm.ruleDtl.goodType
              ? _c("div", [
                  _c("span", [_vm._v("适用货品：")]),
                  _vm.ruleDtl.goodType === 1
                    ? _c("span", [_vm._v("全部商品")])
                    : _vm._e(),
                  _vm.ruleDtl.goodType === 2
                    ? _c("span", [_vm._v("指定商品")])
                    : _vm._e()
                ])
              : _vm._e(),
            _c("div", { staticClass: "box50" })
          ])
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.setName,
            visible: _vm.popVisible,
            width: "550px"
          },
          on: {
            "update:visible": function($event) {
              _vm.popVisible = $event
            }
          }
        },
        [
          _vm.setting === "expiryType"
            ? _c(
                "div",
                { staticClass: "discountingPop" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.pointsRule.expiryType,
                        callback: function($$v) {
                          _vm.$set(_vm.pointsRule, "expiryType", $$v)
                        },
                        expression: "pointsRule.expiryType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("永久有效")
                      ]),
                      _c(
                        "el-radio",
                        { attrs: { label: 2 } },
                        [
                          _c("span", { staticClass: "pad10_r" }, [
                            _vm._v("从获得开始至")
                          ]),
                          _c("el-date-picker", {
                            attrs: {
                              disabled: _vm.pointsRule.expiryType !== 2,
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "default-time": "23:59:59",
                              "picker-options": _vm.pickerOptions,
                              "popper-class": "seller-style",
                              placeholder: "选择日期"
                            },
                            model: {
                              value: _vm.pointsRule.endTime,
                              callback: function($$v) {
                                _vm.$set(_vm.pointsRule, "endTime", $$v)
                              },
                              expression: "pointsRule.endTime"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-radio",
                        { staticClass: "commonValidity", attrs: { label: 3 } },
                        [
                          _c("span", { staticClass: "pad10_r" }, [
                            _vm._v("每笔有效期为")
                          ]),
                          _c("el-input", {
                            attrs: {
                              "popper-class": "seller-style",
                              disabled: _vm.pointsRule.expiryType !== 3
                            },
                            on: {
                              input: function($event) {
                                _vm.pointsRule.expiryRuleKey = _vm.formatNums(
                                  _vm.pointsRule.expiryRuleKey,
                                  false
                                )
                              }
                            },
                            model: {
                              value: _vm.pointsRule.expiryRuleKey,
                              callback: function($$v) {
                                _vm.$set(_vm.pointsRule, "expiryRuleKey", $$v)
                              },
                              expression: "pointsRule.expiryRuleKey"
                            }
                          }),
                          _c(
                            "el-select",
                            {
                              attrs: {
                                "popper-class": "seller-style",
                                placeholder: "请选择"
                              },
                              model: {
                                value: _vm.pointsRule.expiryRuleValue,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.pointsRule,
                                    "expiryRuleValue",
                                    $$v
                                  )
                                },
                                expression: "pointsRule.expiryRuleValue"
                              }
                            },
                            _vm._l(_vm.commonSelectList, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: {
                                  disabled: _vm.pointsRule.expiryType !== 3,
                                  label: item.label,
                                  value: item.value
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c("p", { staticClass: "f12 gray9 lin_20" }, [
                        _vm._v(
                          "“年”支持 1-3 年，“月”支持 1-18 个月，“日”支持 1-365 日。"
                        )
                      ]),
                      _c("p", { staticClass: "f12 gray9 lin_20" }, [
                        _vm._v("示例：若设置为1年，则用户在获取后1年后失效")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.setting === "name"
            ? _c(
                "div",
                [
                  _c("span", [_vm._v("将名称自定义为")]),
                  _c("el-input", {
                    attrs: {
                      maxlength: "5",
                      placeholder: "如：金币。最多5个字"
                    },
                    model: {
                      value: _vm.pointsRule.name,
                      callback: function($$v) {
                        _vm.$set(_vm.pointsRule, "name", $$v)
                      },
                      expression: "pointsRule.name"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.setting === "deductionRatio"
            ? _c(
                "div",
                { staticClass: "discountingPop" },
                [
                  _c("el-input", {
                    on: {
                      input: function($event) {
                        _vm.pointsRule.deductionRatio = _vm.formatNums(
                          _vm.pointsRule.deductionRatio,
                          true
                        )
                      }
                    },
                    model: {
                      value: _vm.pointsRule.deductionRatio,
                      callback: function($$v) {
                        _vm.$set(_vm.pointsRule, "deductionRatio", $$v)
                      },
                      expression: "pointsRule.deductionRatio"
                    }
                  }),
                  _c("span", [_vm._v("可抵用现金1元")])
                ],
                1
              )
            : _vm._e(),
          _vm.setting === "grantType"
            ? _c(
                "div",
                { staticClass: "discountingPop" },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.pointsRule.grantType,
                        callback: function($$v) {
                          _vm.$set(_vm.pointsRule, "grantType", $$v)
                        },
                        expression: "pointsRule.grantType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("支付完成立即发放")
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("确认收货后立即发放")
                      ])
                    ],
                    1
                  ),
                  _c("p", { staticClass: "f12" }, [
                    _vm._v("积分发放后，订单售后退款不退还积分")
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm.setting === "grantLimit"
            ? _c(
                "div",
                [
                  _c("span", [_vm._v("每个客户每天通过消费最多获取")]),
                  _c("el-input", {
                    model: {
                      value: _vm.pointsRule.grantLimit,
                      callback: function($$v) {
                        _vm.$set(_vm.pointsRule, "grantLimit", $$v)
                      },
                      expression: "pointsRule.grantLimit"
                    }
                  }),
                  _c("span"),
                  _c("p", { staticClass: "f12" }, [
                    _vm._v("仅针对每购买金额X元、每成功交易X笔赠送的有效")
                  ])
                ],
                1
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.cancelRule()
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.isSubmit },
                  on: {
                    click: function($event) {
                      return _vm.saveRule()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }